import { render, staticRenderFns } from "./VFlashMessage.vue?vue&type=template&id=52f5a184&scoped=true"
import script from "./VFlashMessage.vue?vue&type=script&lang=js"
export * from "./VFlashMessage.vue?vue&type=script&lang=js"
import style0 from "./VFlashMessage.vue?vue&type=style&index=0&id=52f5a184&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f5a184",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f5a184')) {
      api.createRecord('52f5a184', component.options)
    } else {
      api.reload('52f5a184', component.options)
    }
    module.hot.accept("./VFlashMessage.vue?vue&type=template&id=52f5a184&scoped=true", function () {
      api.rerender('52f5a184', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/volta/VFlashMessage.vue"
export default component.exports